/**
 * Constants instead of typescript enums ---> smaller bundle size
 */
export const AnimateOnClick = '--animate-onclick';
export const SliderWidth = '--width';
export const SliderHeight = '--height';
export const SliderRadius = '--panel-bg-border-radius';

export const SliderBg = '--panel-bg';
export const SliderBgHover = '--panel-bg-hover';
export const SliderBgFill = '--panel-bg-fill';

export const PointerWidth = '--pointer-width';
export const PointerHeight = '--pointer-height';
export const PointerRadius = '--pointer-border-radius';
export const PointerBg = '--pointer-bg';
export const PointerBgHover = '--pointer-bg-hover';
export const PointerBgFocus = '--pointer-bg-focus';
export const PointerShadow = '--pointer-shadow';
export const PointerShadowHover = '--pointer-shadow-hover';
export const PointerShadowFocus = '--pointer-shadow-focus';
export const PointerBorder = '--pointer-border';
export const PointerBorderHover = '--pointer-border-hover';
export const PointerBorderFocus = '--pointer-border-focus';
